(() => {
  const MIN_SCALE = 1;
  const MAX_SCALE = 2.5;
  const SCALE_STEP = 0.25;

  function initializeViewer(root) {
    if (root.dataset.airzoeViewerReady === "true") return;

    const dialog = root.querySelector("[data-airzoe-image-viewer]");
    const gallery = root.querySelector(".dialog-zoomed-gallery");
    const mediaItems = Array.from(
      root.querySelectorAll(".dialog-zoomed-gallery .product-media-container")
    );
    const thumbnails = Array.from(
      root.querySelectorAll(".dialog-thumbnails-list__thumbnail")
    );
    const currentCounter = root.querySelector("[data-airzoe-viewer-current]");
    const zoomInButton = root.querySelector("[data-airzoe-zoom-in]");
    const zoomOutButton = root.querySelector("[data-airzoe-zoom-out]");
    const zoomResetButton = root.querySelector("[data-airzoe-zoom-reset]");

    if (!dialog || !gallery || !mediaItems.length) return;

    let activeIndex = 0;
    let scale = MIN_SCALE;
    let scrollFrame;

    const updateZoomControls = () => {
      if (zoomInButton) zoomInButton.disabled = scale >= MAX_SCALE;
      if (zoomOutButton) zoomOutButton.disabled = scale <= MIN_SCALE;
      if (zoomResetButton) zoomResetButton.textContent = `${Math.round(scale * 100)}%`;
    };

    const applyScale = (nextScale) => {
      scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, nextScale));

      mediaItems.forEach((item, index) => {
        item.style.setProperty(
          "--airzoe-viewer-scale",
          index === activeIndex ? scale : MIN_SCALE
        );
        item.classList.toggle(
          "airzoe-image-viewer__media--zoomed",
          index === activeIndex && scale > MIN_SCALE
        );
      });

      updateZoomControls();
    };

    const selectIndex = (index, resetZoom = true) => {
      if (!Number.isInteger(index) || index < 0 || index >= mediaItems.length) return;

      activeIndex = index;
      if (currentCounter) currentCounter.textContent = `${activeIndex + 1}`;

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        thumbnail.setAttribute("aria-selected", `${thumbnailIndex === activeIndex}`);
      });

      if (resetZoom) applyScale(MIN_SCALE);
    };

    const findClosestMediaIndex = () => {
      const galleryRect = gallery.getBoundingClientRect();
      const galleryCenter = galleryRect.left + galleryRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      mediaItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - galleryCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const handleSelection = (event) => {
      const index = Number(event.detail?.index);
      if (!Number.isNaN(index)) selectIndex(index);
    };

    root.addEventListener("zoom-media:selected", handleSelection);
    root.addEventListener("zoom-media-selected", handleSelection);

    gallery.addEventListener(
      "scroll",
      () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const index = findClosestMediaIndex();
          if (index !== activeIndex) {
            selectIndex(index);
            root.loadHighResolutionImage?.(mediaItems[index]);
          }
        });
      },
      { passive: true }
    );

    zoomInButton?.addEventListener("click", () => applyScale(scale + SCALE_STEP));
    zoomOutButton?.addEventListener("click", () => applyScale(scale - SCALE_STEP));
    zoomResetButton?.addEventListener("click", () => applyScale(MIN_SCALE));

    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) root.closeDialog();
    });

    dialog.addEventListener("close", () => applyScale(MIN_SCALE));
    dialog.addEventListener("keydown", (event) => {
      if (event.key === "+" || event.key === "=") {
        event.preventDefault();
        applyScale(scale + SCALE_STEP);
      } else if (event.key === "-") {
        event.preventDefault();
        applyScale(scale - SCALE_STEP);
      } else if (event.key === "0") {
        event.preventDefault();
        applyScale(MIN_SCALE);
      }
    });

    selectIndex(0);
    root.dataset.airzoeViewerReady = "true";
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll("zoom-dialog").forEach(initializeViewer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();
